import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { P } from 'components/Typography';
import FadeUpWrapper from 'components/FadeUpWrapper';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import TeamImg from 'products/global/assets/img/home/team.png';
import TeamImgMobile from 'products/global/assets/img/home/team_mobile.png';
import Feathers from './components/Feathers';
import { Background, StyledSafetyNet, Title, Description, Team } from './styled';

const SafetyNet = () => {
  const { width: windowWidth } = useWindowSize();
  const { ref: teamRef, inView } = useInView({
    rootMargin:
      windowWidth < SCREEN_SIZES.tabletPortrait ? '0px' : `-${window.innerHeight * 0.2}px`
  });
  const [scaleTeam, setScaleTeam] = useState(false);

  useEffect(() => {
    if (inView) {
      // only set this to true once -> animation only runs on first scroll down
      setScaleTeam(true);
    }
  }, [inView]);

  const teamVariants = {
    normal: { scale: 1 },
    large: { scale: 1.15 }
  };

  return (
    <Background>
      <Feathers />
      <StyledSafetyNet>
        <FadeUpWrapper damping={50} mass={2} yDelta={40}>
          <Title>
            We are building
            <br />a global social
            <br />
            safety net
          </Title>
        </FadeUpWrapper>
        <Description>
          <FadeUpWrapper damping={50} mass={2} yDelta={40}>
            <P variant="dark">
              The internet has allowed many people to live, work and form communities how
              they choose — outside the life script of their home country. The first
              people to take advantage of this opportunity were digital nomads, but now
              remote work is making this lifestyle more common.
            </P>
          </FadeUpWrapper>
          <FadeUpWrapper delay={200} damping={50} mass={2} yDelta={40}>
            <P variant="dark">
              Our products are built and designed by a fully remote team of nomads
              distributed across three continents. SafetyWing was founded to support
              nomads like ourselves by building an adaptable software-based safety net for
              everyone in the world.
            </P>
          </FadeUpWrapper>
        </Description>
      </StyledSafetyNet>
      <Team ref={teamRef}>
        <motion.img
          src={windowWidth > SCREEN_SIZES.tabletPortrait ? TeamImg : TeamImgMobile}
          alt="SafetyWing team"
          variants={teamVariants}
          animate={scaleTeam ? 'normal' : 'large'}
          transition={{ type: 'spring', damping: 300, mass: 2 }}
        />
      </Team>
    </Background>
  );
};

export default SafetyNet;
